import { STATUSES, PRIORITIES } from '../constants';

export function getStatusMeta(key) {
  return STATUSES.find(s => s.key === key) || STATUSES[0];
}

export function getPriorityMeta(key) {
  return PRIORITIES.find(p => p.key === key) || PRIORITIES[2];
}

export function formatDate(d) {
  if (!d) return '-';
  const date = new Date(d);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export function formatDateTime(date) {
  const d = new Date(date);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

export function isOverdue(dueDate, status) {
  if (!dueDate || status === 'completed' || status === 'archived') return false;
  return new Date(dueDate) < new Date();
}

export function generateTaskId() {
  const dateStr = new Date().toISOString().slice(0, 10).replace(/-/g, '');
  const random = String(Math.floor(Math.random() * 900) + 100);
  return `T-${dateStr}-${random}`;
}

export function canEditTask(task, currentUser, role) {
  if (!task || !role) return false;
  if (role.canEditAll) return true;
  if (role.canEditOwn && task.assignee === currentUser) return true;
  if (role.canEditAssigned && (task.assignee === currentUser || task.collaborators.includes(currentUser))) return true;
  return false;
}

export function canDeleteTask(task, currentUser, role) {
  if (!task || !role) return false;
  if (role.canDeleteAny) return true;
  if (role.canDeleteOwn && task.assignee === currentUser) return true;
  return false;
}

export function getFieldPermission(field, role) {
  if (!role) return 'readonly';
  if (role.canEditAll) return 'editable';
  const adminOnlyFields = ['riskLevel', 'llmConfig', 'archived'];
  if (adminOnlyFields.includes(field) && role.key !== 'admin') return 'readonly';
  return 'editable';
}

export function autoDetectRisk(task) {
  if (task.priority === 'urgent' && ['Case/申诉处理', '店铺安全巡检'].includes(task.type)) return 'high';
  if (task.priority === 'urgent') return 'medium';
  if (['Case/申诉处理', '店铺安全巡检'].includes(task.type)) return 'medium';
  return 'low';
}

export function exportToCSV(rows, filename) {
  const headers = Object.keys(rows[0] || {});
  const csv = [
    headers.join(','),
    ...rows.map(r => headers.map(h => {
      const v = r[h];
      if (v == null) return '';
      const s = String(v).replace(/"/g, '""');
      return s.includes(',') || s.includes('\n') ? `"${s}"` : s;
    }).join(','))
  ].join('\n');
  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
}

export function getThisWeekRange() {
  const now = new Date();
  const day = now.getDay();
  const start = new Date(now);
  start.setDate(now.getDate() - (day === 0 ? 6 : day - 1));
  start.setHours(0, 0, 0, 0);
  const end = new Date(start);
  end.setDate(start.getDate() + 6);
  end.setHours(23, 59, 59, 999);
  return [start, end];
}

export function getThisMonthRange() {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), 1);
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
  return [start, end];
}

export function getTodayRange() {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
  return [start, end];
}
